










import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import MixinCharts from '@/plugins/podolib/services/helper/mixins/chart/standard';
import { DrawSVG } from '@/plugins/podolib/services/charts/strike-pattern/strike-pattern-running';

@Component
export default class ChartRunningPhaseAdvancedStrikePattern extends Mixins(MixinCharts) {
  @Prop({ required: false, default: true }) globalType!: boolean;
  @Prop({ required: false, default: 0 }) index!: number;

  graphCanvas: DrawSVG | null = null;

  @Watch('values', { deep: true })
  onValuesChange() {
    this.draw();
  }

  get phases() {
    return {
      leftFoot: {
        angle: this.values.aggregates.left.angle_attack.avg,
        impact: this.values.aggregates.left.f_max.avg,
        angleType: this.getAngleType('left'),
      },
      rightFoot: {
        angle: this.values.aggregates.right.angle_attack.avg,
        impact: this.values.aggregates.right.f_max.avg,
        angleType: this.getAngleType('right'),
      },
    };
  }

  getAngleType(side: string) {
    const values = this.values.aggregates;
    const highestValue = Math.max(
      values[side].percent_fore_foot,
      values[side].percent_mid_foot,
      values[side].percent_rear_foot,
    );
    if (highestValue === values[side].percent_fore_foot) {
      return 'foreFoot';
    } else if (highestValue === values[side].percent_rear_foot) {
      return 'rearFoot';
    } else {
      return 'midFoot';
    }
  }
  draw() {
    const shoesCanvas = {
      leftFoot: this.$refs['leftFoot'] as HTMLCanvasElement,
      rightFoot: this.$refs['rightFoot'] as HTMLCanvasElement,
    };
    this.graphCanvas = new DrawSVG(this.$refs['canvas'] as HTMLCanvasElement, this.phases, shoesCanvas);
    requestAnimationFrame(() => {
      this.graphCanvas!.draw();
    });
  }

  mounted() {
    this.draw();
  }
}
